import React, { useCallback, useState, useEffect, useMemo } from 'react';
import { useLocalizedStrings } from 'app/localization/Context';

import { ReactComponent as IconX } from 'images/general/x.svg';
import { ReactComponent as IconWifi } from 'images/device/add-device/wifi.svg';
import { ReactComponent as IconEyeClosed } from 'images/device/add-device/eye-closed.svg';
import { ReactComponent as IconEyeOpen } from 'images/device/add-device/eye-open.svg';
import { ReactComponent as IconBackBlack } from 'images/general/back-black.svg';

import { ReactComponent as IconAppStore } from 'images/general/app-store.svg';
import { ReactComponent as IconAndroid } from 'images/general/android.svg';


export function ConnectToWifiNetwork({
    dismissHandler, setPageData, connectedSSIDInfo,
    setErrorId, setStage, onPasswordEntered, isSolo,
}) {
    const ad = useLocalizedStrings().addDeviceProcess;

    // const [ssid, setSSID] = useState('');
    const [password, setPassword] = useState('');
    const [usePreviousPassword, setUsePreviousPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const onFocusPassword = useCallback((e) => {
        if (usePreviousPassword) {
            e.preventDefault();
            e.target.select();
            e.target.setSelectionRange(0, 999999);
        }
    }, [usePreviousPassword]);

    const onChangePassword = useCallback((e) => {
        setUsePreviousPassword(false);
        setPassword(e.target.value);
    }, []);

    // const onChangeSSID = useCallback((e) => {
    //     setSSID(e.target.value);
    // }, []);

    const isValidPassword = useMemo(() => {
        return usePreviousPassword || password.length > 7;
    }, [usePreviousPassword, password]);

    // const isValidSSID = useMemo(() => {
    //     return !isSolo || (ssid.length > 0);
    // }, [isSolo, ssid]);

    const nextClick = useCallback(() => {
        // if (isSolo) {
        //     if (isValidPassword && isValidSSID) {
        //         onPasswordEntered(ssid, usePreviousPassword ? undefined : password);
        //     }
        // } else {
        if (isValidPassword) {
            onPasswordEntered(connectedSSIDInfo.name, usePreviousPassword ? undefined : password, connectedSSIDInfo.bssid);
        }
        // }
    }, [connectedSSIDInfo, password, isValidPassword, onPasswordEntered, usePreviousPassword]);

    useEffect(() => {
        if (connectedSSIDInfo.remembered_password === true) {
            setUsePreviousPassword(true);
            setShowPassword(false);
        }
    }, [connectedSSIDInfo.remembered_password]);

    return (
        <div className="add-device-page-content">
            <IconX className="nav-icon" /> <div className="nav-button" onClick={dismissHandler} />

            <div className="header">{ad.connectNetwork}</div>

            <div className="warn-info">{ad.wifiGHz}</div>


            {/* <div className="input-header-label for-ssid">{ad.ssid}</div>
                    <div className="input-container" dir="ltr" lang="en">
                        <input className="input" value={ssid} onChange={onChangeSSID} type="text"></input>
                    </div> */}
            <div className="wifi-group">
                <IconWifi className="icon" />
                <div className="label">{
                    connectedSSIDInfo ? (connectedSSIDInfo.name ? connectedSSIDInfo.name : "") : ""
                }</div>
                {/* <div /> */}
                {/* <div className="change-button-border">
                            <div className="label">{ad.change}</div>
                            <IconChange className="icon" />
                        </div> */}
            </div>


            <div className="input-header-label for-wifi-password">{ad.password}</div>
            <div className="input-container" dir="ltr" lang="en">
                {
                    !usePreviousPassword ?
                        React.createElement(showPassword ? IconEyeOpen : IconEyeClosed, { className: "eye icon" }) : null
                }
                <input className="input"
                    value={usePreviousPassword ? '............' : password}
                    onChange={onChangePassword} onFocus={onFocusPassword} onMouseUp={(e) => e.preventDefault()}
                    type={showPassword ? "text" : "password"}></input>
                {!usePreviousPassword ? <div className="eye button" onClick={() => { setShowPassword(!showPassword) }} /> : null}
            </div>


            {/* {!isValidSSID ? <div className="error-label">{ad.ssidError}</div> : null} */}
            {!isValidPassword ? <div className="error-label">{ad.passwordError}</div> : null}

            <div className="bottom-blue-button" onClick={nextClick} style={{ opacity: (isValidPassword) ? 1 : 0.3 }}>
                <div>{ad.next}</div> <IconBackBlack className="icon-180" />
            </div>
        </div>
    );
}

export function AskWifiManualESPTouch({ dismissHandler, connectedSSIDInfo, startSearchWithoutESPTouch }) {
    const ad = useLocalizedStrings().addDeviceProcess;

    const showLocationWarning = (connectedSSIDInfo && connectedSSIDInfo.error === 1)

    return (
        <div className="add-device-page-content">
            <IconX className="nav-icon" /> <div className="nav-button" onClick={dismissHandler} />

            <div className="header">{ad.connectNetwork}</div>

            {showLocationWarning ?
                <div className="warn-info">{ad.locationWarning}</div> :
                <div className="warn-info">{ad.esptouchHintToUseAndroidClient}</div>}

            <div className="reset-instruction more-relaxed" style={{ marginTop: 16 }}>{ad.espTouchInstruction1}</div>

            <div className="download-link">
                <IconAppStore className="icon" />
                <div className="textarea-container">
                    <textarea className="textarea" readOnly={true} value={"https://apps.apple.com/us/app/espressif-esptouch/id1071176700"}></textarea>
                </div>
            </div>

            <div className="download-link">
                <IconAndroid className="icon" />
                <div className="textarea-container">
                    <textarea className="textarea" readOnly={true} value={"https://github.com/EspressifApp/EsptouchForAndroid/releases/latest"}></textarea>
                </div>
            </div>

            <div className="reset-instruction more-relaxed">{ad.espTouchInstruction23}</div>

            <div className="bottom-blue-button" onClick={startSearchWithoutESPTouch}>
                <div>{ad.deviceLEDColorBecameOrange}</div> <IconBackBlack className="icon-180" />
            </div>
        </div>
    );
}
